import { get, post, patch } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchCoursePage = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}`, {
    include: [
      'modules',
      // 'modules.userModule',
      'modules.moduleScreens',
      'modules.moduleLessons.lesson',
      'modules.moduleLessons.lesson.userLesson',
      // 'modules.moduleLessons.markers',
      'themes',
      'userCourse',
      'activeMap',
      'activeMap.imageMedia',
      'activeMap.markers',
    ],
  })

export const fetchCourseUserState = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/user-state`)

export const joinCourse = (id: string): Promise<AxiosResponse> =>
  post(`/courses/courses/${id}/join`)

export const joinModule = (id: string, mid: string): Promise<AxiosResponse> =>
  post(`/courses/courses/${id}/modules/${mid}/join`)

export const repayCourse = (id: string): Promise<AxiosResponse> =>
  patch(`/courses/courses/${id}/repay`)
